import React from 'react';
import { useForm } from 'react-hook-form';
import { CreateChancel, TextareaCustom } from 'components';
import { useModal, Images } from 'utils';

export const CustomAiPromptModal = ({ onSave, initialPrompt = '' }) => {
    const { close } = useModal();
    const isEdit = !!initialPrompt;
    const { handleSubmit, control } = useForm({
        defaultValues: { customPrompt: initialPrompt },
    });

    const handleSave = (data) => {
        const trimmed = (data.customPrompt || '').trim();
        onSave(trimmed || null);
        close();
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">{isEdit ? 'Edit Custom AI Prompt' : 'Add Custom AI Prompt'}</p>

            <div className="ai-summary-note-box">
                <img
                    style={{
                        filter: 'brightness(0) saturate(100%) invert(22%) sepia(55%) saturate(6628%) hue-rotate(210deg) brightness(100%) contrast(91%)',
                    }}
                    src={Images.infoGrayIcon}
                    alt="info"
                />
                <p>These instructions will be used by AI when generating the summary for this field.</p>
            </div>

            <form onSubmit={handleSubmit(handleSave)}>
                <div className="modal-body-wrapper">
                    <TextareaCustom
                        control={control}
                        name="customPrompt"
                        label="Custom Prompt"
                        variant={'outlined'}
                        maxLength={1000}
                        allowCharacter={true}
                    />
                </div>
                <CreateChancel
                    type="submit"
                    create={isEdit ? 'Save Changes' : 'Save Prompt'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                />
            </form>
        </div>
    );
};
